import { render, staticRenderFns } from "./BillNegotiationCard.vue?vue&type=template&id=5487e1ef&"
import script from "./BillNegotiationCard.vue?vue&type=script&lang=js&"
export * from "./BillNegotiationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports